import { sendToGTM } from '../context/utils/GoogleTagManager';
export var orderError = function orderError(props) {
  var message = props.message;
  var event = {
    event: 'order_error',
    detailed_event: 'Order Error',
    event_data: {
      error_message: message ? message : ''
    }
  };
  sendToGTM({
    data: event
  });
};